import { render, staticRenderFns } from "./IgModal.vue?vue&type=template&id=67dc3085&"
import script from "./IgModal.vue?vue&type=script&lang=js&"
export * from "./IgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports